import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import './NavigationMenu.css';
import Footer from '../Footer/Footer';
import Home from '../../pages/LernHome/Home';
import Courses from '../../pages/LernCourses/Courses';
import Blog from '../../pages/LernBlog/Blog';
import LogIn from '../../pages/LernLogIn/LogIn';
import RecoverPassword from '../../pages/LernRecoverPassword/RecoverPassword';
import CourseItem from '../../pages/LernCourseItem/CourseItem';
import CourseEnroll from '../../pages/LernCourseEnroll/CourseEnroll';
import AdminPortal from '../../pages/LernAdminPortal/AdminPortal';
import StudentPortal from '../../pages/LernStudentPortal/StudentPortal';
import Password from '../../pages/LernPassword/Password';
import LogOut from '../../pages/LogOut/LogOut';

const user = localStorage.getItem('user') ?? '';
const sid = localStorage.getItem('sid') ?? '';

const navitems = user ? [
    {navname: 'Password', navlink: `/studentpassword/${sid}`, navclass: 'nav-item'},
    {navname: 'Log Out', navlink: '/logout', navclass: 'nav-item'}
]
:
[
    {navname: 'Home', navlink: '/', navclass: 'nav-item'},
    {navname: 'Courses', navlink: '/courses', navclass: 'nav-item'},
    {navname: 'Blog', navlink: '/blog', navclass: 'nav-item'},
    {navname: 'Log In', navlink: '/login', navclass: 'nav-item'}
]
;

const NavigationMenu = () => {
    const { pathname } = useLocation();

    const [ showMenu, setShowMenu ] = useState(false);

    return (
        <div className='lern-nav'>
            <nav className='nav-menu'>
                <div className='nav-logo'>
                    <img src="/images/logo_innovate.png" alt='Lern Tutors Logo' />
                </div>
                <ul className={`nav-list ${showMenu ? 'show-menu' : ''}`}>
                    {navitems.map((navitem) => pathname.includes(navitem.navlink) && pathname.slice(1) === navitem.navlink.slice(1) ? 
                        (
                            <li key={navitem.navname} className={navitem.navclass + ' active'} onClick={() => setShowMenu(state => !state)}>
                                <Link to={navitem.navlink}>{navitem.navname}</Link>
                            </li>
                        ):
                        (
                            <li key={navitem.navname} className={navitem.navclass} onClick={() => setShowMenu(state => !state)}>
                                <Link to={navitem.navlink}>{navitem.navname}</Link>
                            </li>
                        )
                    )}
                </ul>
                <div className="nav-toggle">
                    <input id="nav-input" type="checkbox" checked={showMenu} onChange={() => setShowMenu(state => !state)} />
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </nav>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/courses' element={<Courses />} />
                <Route path='/blog' element={<Blog />} />
                <Route path='/login' element={<LogIn />} />
                <Route path='/logout' element={<LogOut />} />
                <Route path='/recoverpassword' element={<RecoverPassword />} />
                <Route path='/courses/:cid' element={<CourseItem />} />
                <Route path='/enroll/:cid' element={<CourseEnroll />} />
                <Route path='/adminportal/:aduser' element={<AdminPortal />} />
                <Route path='/studentportal/:sid' element={<StudentPortal />} />
                <Route path='/studentpassword/:sid' element={<Password />} />
            </Routes>
            <Footer />
        </div>
    )
}

export default NavigationMenu;